export default __webpack_public_path__ + "static/media/canpilot.929bb7e2.jpg";